exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.html-content-editor[data-v-191e9148] {\n  font-size: 13px;\n}\n", ""]);

// exports
